import { render, staticRenderFns } from "./label-filter.vue?vue&type=template&id=48a3c1e3&scoped=true&"
import script from "./label-filter.vue?vue&type=script&lang=js&"
export * from "./label-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3c1e3",
  null
  
)

export default component.exports